module.exports = __webpack_public_path__ + "static/media/ic_calendar_next_diabled.e4f97a4f.svg";